<!--实名认证-->
<template>
  <div class="certification-container" :style="'min-height:'+min_height+'px;'">
    <div class="certification-content">
      <div v-if="isFinished" class="real-true">
        <div class="real-text">
          <p class="SourceHanSansCN"><i class="iconfont icon-anquan"/><span>已完成实名认证，并为您开启隐私保护</span></p>
        </div>
        <p class="bigger-title SourceHanSansCN">已完成实名认证</p>
        <div class="real-info SourceHanSansCN">
          <span class="gray-span">真实姓名</span>
          <span>{{ parseStringToStarNmae(info.nikeName) }}</span>
        </div>
        <div class="real-info SourceHanSansCN">
          <span class="gray-span">身份证号</span>
          <span>{{ info.idenitityNum }}</span>
        </div>
      </div>
      <div v-else class="real-false">
        <p class="title SourceHanSansCN">上传身份证</p>
        <el-form :model="certificationInfo" :rules="rules" ref="realForm" class="realForm">
          <el-form-item prop="upLoadImg1" class="img_upload">
            <el-upload class="avatar-uploader"
                       action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="1"
                       ref="upload1" :on-remove="handleRemove1" :on-preview="handlePictureCardPreview"
                       :on-change="fileListChange1" accept=".png,.gif,.jpeg,.jpg"
                       list-type="picture-card" :file-list="fileList1" :before-upload="beforeUpload1">
              <img v-if="certificationInfo.upLoadImg1" :src="certificationInfo.upLoadImg1" class="avatar" width="148px"
                   height="148px">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="img_line_tips SourceHanSansCN">上传人像面</div>
          </el-form-item>
          <el-form-item prop="upLoadImg2" class="img_upload">
            <el-upload class="avatar-uploader"
                       action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="1"
                       ref="upload2" :on-remove="handleRemove2" :on-preview="handlePictureCardPreview"
                       :on-change="fileListChange2" accept=".png,.gif,.jpeg,.jpg"
                       list-type="picture-card" :file-list="fileList2" :before-upload="beforeUpload2">
              <img v-if="certificationInfo.upLoadImg2" :src="certificationInfo.upLoadImg2" class="avatar" width="148px"
                   height="148px">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="img_line_tips SourceHanSansCN">上传国徽面</div>
          </el-form-item>
        </el-form>
        <p class="title SourceHanSansCN">身份证信息</p>
        <el-descriptions :column="1" border style="width: 43%">
          <el-descriptions-item label="姓名：">{{certificationInfo.name || ''}}</el-descriptions-item>
          <el-descriptions-item label="性别：" v-if="certificationInfo.sex">{{certificationInfo.sex==0 ? '男' :'女' }}</el-descriptions-item>
          <el-descriptions-item label="性别：" v-else>{{certificationInfo.sex || '' }}</el-descriptions-item>
          <el-descriptions-item label="身份证：">{{parseStringToStar(certificationInfo.idCard) || ''}}</el-descriptions-item>
          <el-descriptions-item label="证件有效期：">{{certificationInfo.deadline || ''}}</el-descriptions-item>
        </el-descriptions>
        <p>
          <el-button type="danger" @click="submitCertification">提交</el-button>
        </p>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import {accountManage} from '@/api/systemSetting'
export default {
  name: "certification",
  data() {
    const idCardValidity = (rule, code, callback) => {
      let city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      let tip = ""
      let pass = true
      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误"
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "身份证输入错误"
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          // 加权因子
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          let sum = 0
          let ai = 0
          let wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            tip = "身份证输入错误"
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
    }
    return {
      certificationInfo: {
        realName: 0,
        name: '',
        idCode: '',
        id: 0,
        sex:null,
        idCard:'',
        deadline:'',
      },
      isFinished:false,
      info:{},
      fileList1: [],
      fileList2: [],
      rules: {
        upLoadImg1: [
          {required: true, trigger: 'blur', message: '请上传上传人像面!'}
        ],
        upLoadImg2: [
          {required: true, trigger: 'blur', message: '请上传国徽面!'}
        ],
        name: [
          {required: true, trigger: 'blur', message: '请输入您的真实姓名!'}
        ],
        sex: [
          {required: true, trigger: 'blur', message: '请选择您的性别!'}
        ],
        idCard: [
          {required: true, trigger: 'blur', message: '输入您的身份证号码!'},
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            trigger: 'blur',
            message: '请输入正确的证件号'
          },
          {validator: idCardValidity, trigger: 'blur'}
        ],
        deadline: [
          {required: true, trigger: 'blur', message: '请选择您的身份证有效期!'}
        ],
        dialogImageUrl: '',
        dialogVisible: false,
      },
      dialogImageUrl: '',
      dialogVisible: false,
      min_height: document.documentElement.clientHeight - 396,
      uid:0,
    }
  },
  methods: {
    /*手机号处理*/
    parseStringToStar(str) {
      if (str!=''){
        let start = str.slice(0, 3)
        let end = str.slice(-2)
        return `${start}***********${end}`
      }
    },
    /*姓名处理*/
    parseStringToStarNmae(str) {
      let start=str.charAt(0);
      return str.replace(start,"*")
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 网络请求 判断是否已经认证
    accountManageMethod() {
      this.loading = true
      accountManage({userId: this.uid,request:'form',uid: this.uid}).then((res) => {
        if(res.code == 200) {
          this.loading = false
          this.status = res.content.entity ? res.content.entity.verifiedStatus : null
          if(this.status == 0 || this.status == 1){
            this.isFinished = true
            this.info = res.content.entity
          }else {
            this.isFinished = false
          }
        }
      })
    },
    // 图片被删除时1
    handleRemove1(file, fileList) {
      if (fileList.length == 0) {
        setTimeout(() => {
          document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'block'
        }, 1000)
      }
    },
    // 图片被删除时2
    handleRemove2(file, fileList) {
      if (fileList.length == 0) {
        setTimeout(() => {
          document.getElementsByClassName('el-upload--picture-card')[1].style.display = 'block'
        }, 1000)
      }
    },
    // 图片上传前1
    beforeUpload1(file) {
      let _this = this
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          resolve()
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        let fd = new FormData();
        fd.append('file', file);//传文件
        this.uploadImgToWangSuMethod(fd, 1)
        return file;
      }, () => {
        _this.$message.error('图片尺寸限制为800 x 800以上，大小不可超过1MB')
        return Promise.reject();
      });
      return false
    },
    // 图片上传前2
    beforeUpload2(file) {
      let _this = this
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          resolve()
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        let fd = new FormData();
        fd.append('file', file);//传文件
        this.uploadImgToWangSuMethod(fd, 2)
        return file;
      }, () => {
        _this.$message.error('图片尺寸限制为800 x 800以上，大小不可超过1MB')
        return Promise.reject();
      });
      return false
    },
    // 网络请求 上传图片转化为链接
    uploadImgToWangSuMethod(file, num) {
      /*uploadImgToWangSu(file).then((res) => {
        console.log(res,'图片链接')
        if(res.data.code == 200) {
          if(num == 1) {
            this.ruleForm.upLoadImg1 = res.data.content.imgPath
          }else {
            this.ruleForm.upLoadImg2 = res.data.content.imgPath
          }
        }else {
          this.loading = false
        }
      })*/
    },
    // 图片list改变时
    fileListChange1(file, fileList) {
      if (fileList.length == 1) {
        document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'none'
      } else {
        document.getElementsByClassName('el-upload--picture-card')[0].style.display = 'block'
      }
    },
    // 图片list改变时2
    fileListChange2(file, fileList) {
      if (fileList.length == 1) {
        document.getElementsByClassName('el-upload--picture-card')[1].style.display = 'none'
      } else {
        document.getElementsByClassName('el-upload--picture-card')[1].style.display = 'block'
      }
    },
    // 认证身份证请求
    saveCertificationMethod() {
      let cid = JSON.parse(sessionStorage.getItem('cid'))
      let obj = {
        cid: cid.cid,
        gender: this.ruleForm.sex, //性别 0男 1女
        identityimgBack: this.ruleForm.upLoadImg2, //身份证反面照片
        identityimgFront: this.ruleForm.upLoadImg1, //身份证正面照片
        idenitity_num: this.ruleForm.idCard, //身份证号码
        indate: this.ruleForm.deadline, //有效期
        realname: this.ruleForm.name, //真实姓名
        type: 0, //0身份证 1其他
        request: 'form'
      }
      /*saveCertification(obj).then((res) => {
        if(res.data.code == 200) {
          this.$message.success('提交成功!')
          this.accountManageMethod()
        }else {
          this.$message.error(res.data.msg)
        }
        this.loading = false
      })*/
    },
    // 点击提交
    submitCertification() {
      this.loading = true
      this.$refs.upload1.submit()
      this.$refs.upload2.submit()
      setTimeout(() => {
        this.$refs.realForm.validate((val) => {
          if (val) {
            this.saveCertificationMethod()
          } else {
            return false
          }
        })
      }, 2000)
    }
  },
  created() {
    this.uid=JSON.parse(sessionStorage.getItem('loginData')).cid;
    this.accountManageMethod()
  }
}
</script>
<style scoped>
.certification-container >>> .el-form-item__content {
  margin-right: 20px;
}

.certification-container >>> .el-upload--picture-card {
  background-color: #ffffff;
  border: 1px solid #DDDDDD;
  width: 200px;
  height: 120px;
  line-height: 140px;
}

.certification-container >>> .el-upload--picture-card i {
  font-size: 36px;
  color: #DDDDDD;
}
.certification-container >>> .el-descriptions-item__content {
  border: 1px solid #ffffff;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  color: #333333;
  font-size: 14px;
  background: #ffffff;
  padding: 10px 0px;
}
.certification-container >>> .el-descriptions-item__label.is-bordered-label {
  color: #999999;
  background: #ffffff;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  border: 1px solid #ffffff;
  font-size: 14px;
  padding: 10px 0px;
}
.certification-container >>> .certification-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}

.certification-container >>> .certification-content .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.certification-container {
  padding: 30px;
  background: #ffffff;

  .certification-content {
    .real-true {
      .real-text {
        display: flex;
        justify-content: start;
        align-items: center;
        flex-direction: inherit;
        text-align: center;
        box-sizing: border-box;

        p {
          margin-block-start: 0px;
          font-size: 14px;
          color: #333333;

          .icon-anquan {
            color: #2FE4BD;
            font-size: 16px;
            padding-right: 5px;
          }
        }
      }

      .bigger-title {
        font-size: 20px;
        color: #333333;
      }

      .real-info {
        display: flex;
        width: 380px;
        justify-content: space-between;
        line-height: 40px;

        span {
          font-size: 14px;
          color: #333333;
        }

        .gray-span {
          color: #999999;
        }
      }
    }

    .real-false {
      .title {
        font-size: 16px;
        color: #333333;
        margin-block-start: 0px;
      }

      .img_line_tips {
        text-align: center;
        font-size: 14px;
        color: #333333;
      }

      .img_upload {
        display: inline-block;
      }

      .avatar-uploader {
        height: 130px;
      }
    }
  }
}
</style>